import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import discountService from "services/discount";

const initialState = {
  discounts: {
    items: [],
    totalCount: 0,
  },
  selectedDiscount: {},
  getDiscounts: {
    status: "idle",
    error: false,
  },
  generateCode: {
    status: "idle",
    error: false,
  },
};

export const getDiscountsAsync = createAsyncThunk(
  "discounts/getDiscountsAsync",
  async (queryParams) => {
    const res = await discountService.getAll(queryParams);
    return res.data;
  }
);

export const addDiscountAsync = createAsyncThunk(
  "discounts/addDiscountAsync",
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await discountService.create(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editDiscountAsync = createAsyncThunk(
  "discounts/editDiscountAsync",
  async ({ discountId, data }, { rejectWithValue }) => {
    try {
      const res = await discountService.update(discountId, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteDiscountAsync = createAsyncThunk(
  "discounts/deleteDiscountAsync",
  async ({ discountId }) => {
    await discountService.remove(discountId);
    return { discountId };
  }
);

export const generateCodeAsync = createAsyncThunk(
  "discounts/generateCodeAsync",
  async () => {
    const res = await discountService.generateCode();
    return res.data;
  }
);

export const verifyDiscountCodeAsync = createAsyncThunk(
  "discounts/verifyDiscountCodeAsync",
  async (queryParams, { rejectWithValue }) => {
    try {
      const res = await discountService.verifyDiscountCode(queryParams);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const discountsSlice = createSlice({
  name: "discounts",
  initialState,
  reducers: {
    updateDiscountSlice: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetDiscountsSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDiscountsAsync.pending, (state) => {
        state.getDiscounts.status = "loading";
        state.getDiscounts.error = false;
      })
      .addCase(getDiscountsAsync.fulfilled, (state, action) => {
        state.getDiscounts.status = "idle";
        state.discounts = action.payload;
      })
      .addCase(getDiscountsAsync.rejected, (state, action) => {
        state.getDiscounts.status = "failed";
        state.getDiscounts.error =
          action?.payload?.messageText ||
          action?.error?.message ||
          "Unknown error";
      })
      .addCase(generateCodeAsync.pending, (state) => {
        state.generateCode.status = "loading";
        state.generateCode.error = false;
      })
      .addCase(generateCodeAsync.fulfilled, (state) => {
        state.generateCode.status = "idle";
      })
      .addCase(generateCodeAsync.rejected, (state, action) => {
        state.generateCode.status = "failed";
        state.generateCode.error =
          action?.payload?.messageText ||
          action?.error?.message ||
          "Unknown error";
      });
  },
});

export const { updateDiscountSlice, resetDiscountsSlice } =
  discountsSlice.actions;

export default discountsSlice.reducer;
